import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
import { faChevronLeft, faSquareCheck } from "@fortawesome/pro-regular-svg-icons";
import { useAuth } from "@qure/qure-auth";
import AwesomeIcon from "../AwesomeIcon";
import { ReminderCard } from "./ReminderList/components";
var ReminderList = function ReminderList(_ref) {
  var _userInfo$details;
  var data = _ref.data,
    patient_uid = _ref.patient_uid,
    onEditReminder = _ref.onEditReminder,
    onAddNewReminder = _ref.onAddNewReminder,
    refetchReminders = _ref.refetchReminders,
    onBackToSummary = _ref.onBackToSummary,
    workspaceId = _ref.workspaceId,
    activeReminderId = _ref.activeReminderId;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var currentUserEmail = userInfo === null || userInfo === void 0 || (_userInfo$details = userInfo.details) === null || _userInfo$details === void 0 ? void 0 : _userInfo$details.email;
  var sorted = _toConsumableArray(data).sort(function (a, b) {
    return new Date(a.remind_after).getTime() - new Date(b.remind_after).getTime();
  });
  var myTasks = sorted.filter(function (r) {
    var _r$owned_by_info;
    return !r.resolved && ((_r$owned_by_info = r.owned_by_info) === null || _r$owned_by_info === void 0 ? void 0 : _r$owned_by_info.email) === currentUserEmail;
  });
  var otherTasks = sorted.filter(function (r) {
    var _r$owned_by_info2;
    return !r.resolved && ((_r$owned_by_info2 = r.owned_by_info) === null || _r$owned_by_info2 === void 0 ? void 0 : _r$owned_by_info2.email) !== currentUserEmail;
  });
  var completed = sorted.filter(function (r) {
    return r.resolved;
  });
  var sections = [{
    key: "my",
    label: t("label.my_tasks"),
    items: myTasks,
    emptyMessage: t("message.no_my_tasks")
  }, {
    key: "other",
    label: t("label.other_tasks"),
    items: otherTasks,
    emptyMessage: t("message.no_tasks")
  }, {
    key: "completed",
    label: t("label.completed"),
    items: completed,
    emptyMessage: t("message.no_completed_tasks")
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden bg-white text-gray-800 dark:bg-gray-800 dark:text-gray-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center px-5 py-[7px] dark:bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    onClick: onBackToSummary,
    className: "hover:bg-gray-100 dark:hover:bg-gray-700 -ml-2 px-2 rounded transition-colors cursor-pointer"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    size: "sm",
    className: "text-gray-800 dark:text-gray-200"
  })), /*#__PURE__*/React.createElement("span", {
    className: "flex-1 ml-3 font-medium text-base"
  }, t("key.tasks"))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col grow h-[1px] p-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grow h-[1px] overflow-y-auto scrollbar-light dark:scrollbar"
  }, sections.map(function (_ref2) {
    var key = _ref2.key,
      label = _ref2.label,
      items = _ref2.items,
      emptyMessage = _ref2.emptyMessage;
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "flex flex-col mb-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-2 py-2 sticky top-0 bg-white dark:bg-gray-800 z-10"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-[12px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "text-[12px] font-semibold leading-none rounded-full bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-2 py-1 ml-1"
    }, items.length)), items.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "space-y-[20px]"
    }, items.map(function (reminder) {
      return /*#__PURE__*/React.createElement(ReminderCard, _extends({
        key: reminder.id
      }, reminder, {
        workspaceId: workspaceId,
        activeReminderId: activeReminderId,
        onClick: function onClick() {
          return onEditReminder(reminder);
        }
      }));
    })) : /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center justify-center gap-2 py-6 rounded-xl border border-dashed border-gray-200 dark:border-gray-700"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faSquareCheck,
      size: "lg",
      className: "text-gray-400 dark:text-gray-500"
    }), /*#__PURE__*/React.createElement("p", {
      className: "text-[12px] text-gray-400 dark:text-gray-500"
    }, emptyMessage)));
  })), /*#__PURE__*/React.createElement("button", {
    className: "w-full bg-teal-600 hover:bg-teal-700 dark:bg-transparent dark:hover:bg-teal-600 border-2 border-teal-600 dark:border-teal-600 text-white rounded-md transition-colors flex-shrink-0 py-[10px]",
    onClick: onAddNewReminder
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-base"
  }, "+ ", t("label.add_new")))));
};
export default ReminderList;